import __request__ from "routing/request";
export function createConfig(config, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.datalake/data_lake/backends", config, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAll(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datalake/data_lake/backends", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateConfig(config, backendId, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.datalake/data_lake/backends/${backendId}`, config, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getConfig(backendId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.datalake/data_lake/backends/${backendId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.datalake/data_lake/backends/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
